// src/utils/inventoryCsv.js
// --- UPDATE (Inventory MOW+ v2) — NEW FILE -----------------------------------------------
// Client-side CSV helpers for the inventory screens (audit ledger, history, templates, draft PO).
// Values are quoted and escaped; a leading = + - @ is prefixed with ' so spreadsheets do not run
// it as a formula (CSV injection).
// --- END UPDATE ---------------------------------------------------------------------------
const cell = (v) => {
    if (v === null || v === undefined) return '';
    let s = v instanceof Date ? v.toISOString() : String(v);
    if (/^[=+\-@]/.test(s) && !/^-?\d+(\.\d+)?$/.test(s)) s = `'${s}`;
    return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};
export const toCsv = (headers, rows) => [headers.map(cell).join(','), ...rows.map((r) => r.map(cell).join(','))].join('\r\n');

export function downloadCsv(filename, headers, rows) {
    const blob = new Blob([`﻿${toCsv(headers, rows)}`], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => { try { URL.revokeObjectURL(url); } catch (_) { /* */ } }, 1500);
    return rows.length;
}

/** Minimal CSV parser for previews (quotes, escaped quotes, CRLF, BOM). */
export function parseCsv(text) {
    const src = String(text || '').replace(/^﻿/, '');
    const rows = []; let row = []; let c = ''; let quoted = false;
    for (let i = 0; i < src.length; i++) {
        const ch = src[i];
        if (quoted) { if (ch === '"' && src[i + 1] === '"') { c += '"'; i++; } else if (ch === '"') quoted = false; else c += ch; }
        else if (ch === '"') quoted = true;
        else if (ch === ',') { row.push(c); c = ''; }
        else if (ch === '\n' || ch === '\r') { if (ch === '\r' && src[i + 1] === '\n') i++; row.push(c); rows.push(row); row = []; c = ''; }
        else c += ch;
    }
    if (c !== '' || row.length) { row.push(c); rows.push(row); }
    return rows.filter((r) => r.some((v) => String(v).trim() !== ''));
}

export const stamp = () => new Date().toISOString().slice(0, 10);
